import { RootState } from "../index";

export const selectCart = (state: RootState) => state.cart.products;
